import React from 'react';

import { Person } from './Person';
import st from './shared.module.sass';
import type { PersonSelectorProps } from './types';

export function PersonSelector({ personList, selectedId, onSelect }: PersonSelectorProps): React.JSX.Element {
  return (
    <div className={st.PersonSelector}>
      {personList.map((person) => (
        <Person
          checked={person.id === selectedId}
          key={person.id}
          onChange={() => onSelect?.(String(person.id))}
          {...person}
        />
      ))}
    </div>
  );
}
